
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AdLabels',
  props: {
    ad: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
    },
  },
});
